// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VsyS6","type":"styles_type__1iO2k","choices":"styles_choices__2L4iU"};